module.exports = __webpack_public_path__ + "img/pdf-icon.7e1b4a5c.svg";